import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { LoggedInInfoService } from "../../../../services/loggedInInfo/logged-in-info.service";
import { OrganizationLogicService } from "../../../../services/organization-logic/organization-logic.service";
import {
  RnOrganizationPackagePoolsForListVM,
  RnOrganizationsProfileVM,
} from "../../../../services/rnapi2-service/models/models";
import { CollectionView } from "@mescius/wijmo";

@Component({
    selector: "app-wlp-inventory-table",
    templateUrl: "./wlp-inventory-table.component.html",
    styleUrls: ["./wlp-inventory-table.component.scss"],
    standalone: false
})
export class WlpInventoryTableComponent {
  private readonly orgLogicService = inject(OrganizationLogicService);
  private readonly loggedInUserService = inject(LoggedInInfoService);


  getWlpPackageText = "";
  @Input() set WLPPackages(list: Array<RnOrganizationPackagePoolsForListVM>) {
    this._packageList = list;
    this.ShowPackages = this._packageList?.length > 0;
    this.packageCollectionView = new CollectionView(list);
  }

  @Input() set WLPAddOns(list: Array<RnOrganizationPackagePoolsForListVM>) {
    this._addOnList = list;
    this.ShowAddOns = this._addOnList?.length > 0;
    this.addOnCollectionView = new CollectionView(list);
  }

  @Input() set OrgProfile(profile: RnOrganizationsProfileVM) {
    this.orgProfile = profile;
    if (this.orgProfile) {
      this.GetWlpPackageText();
      this.setupColumnsForTables();
    }
  }

  @Output() PackagePoolSelected =
    new EventEmitter<RnOrganizationPackagePoolsForListVM>();

  public ShowPackages = false;
  public ShowAddOns = false;
  public canOpenPackagesAddons = false;
  packageCollectionView!: CollectionView<any>;
  addOnCollectionView!: CollectionView<any>;

  public SelectPackage(orgPackPool: RnOrganizationPackagePoolsForListVM) {
    if (this.PackagePoolSelected) {
      this.PackagePoolSelected.emit(orgPackPool);
    }
  }

  public GetWlpPackageText(): void {
    if (this.orgProfile?.CustomerType) {
      if (this.loggedInUserService.GetWLPConfig) {
        const wlpConfigData = this.loggedInUserService?.GetWLPConfig()?.data;
        if (wlpConfigData) {
          this.getWlpPackageText =
            Object.values(wlpConfigData)[
              Object.keys(wlpConfigData).indexOf("packages_addon_tab_message")
            ];
        } else {
          this.getWlpPackageText = `Missing message for packages_addon_tab_message`;
        }
      }
    }
  }

  private setupColumnsForTables() {
    this.GetWlpPackageText();
    const loggedInUser = this.loggedInUserService.GetLoggedInUser();
    if (!loggedInUser) {
      return false;
    }
    const ASNRMALLPK = this.loggedInUserService.loggedInUserHasRights([
      "ASNRMALLPK",
    ]);
    const isInternal = loggedInUser.IsInternal();
    const loggedInUserOrg = this.loggedInUserService.GetLoggedInUserOrg();
    this.canOpenPackagesAddons = this.orgLogicService.CanOpenPackagesAddOns(
        ASNRMALLPK,
        isInternal,
        this.orgProfile,
        loggedInUserOrg,
      );
  }

  private orgProfile: RnOrganizationsProfileVM;
  private _packageList: Array<RnOrganizationPackagePoolsForListVM>;
  private _addOnList: Array<RnOrganizationPackagePoolsForListVM>;
}
